export default __webpack_public_path__ + "static/media/updated-ISSO.a6d4c867.pdf";